import { Grid, IconButton, Typography } from "@material-ui/core";
import Card from "../../../../components/cards/Card";
import styled from "styled-components";
import InputBaseDecimalErp from "../../../../components/basics/InputBaseDecimalErp";
import Btn from "../../../../components/buttons/Btn";
import { Dialog } from "@material-ui/core";

const primary = (props) => props.theme.palette.primary;
const blue = (props) => props.theme.palette.blue;
const lightgrey = (props) => props.theme.palette.lightgrey;
const grey = (props) => props.theme.palette.grey;
const secondary = (props) => props.theme.palette.secondary;
const lightgreen = (props) => props.theme.palette.lightgreen;

const montserrat = (props) => props.theme.fonts.montserrat;
const mulish = (props) => props.theme.fonts.mulish;
const opensans = (props) => props.theme.fonts.opensans;

export const Header = styled.div``;

export const Body = styled.div``;

export const TypographyStyled = styled(Typography)`
  font-weight: bold !important;
  font-size: 18px !important;
  font-family: ${opensans} !important;
`;

export const CardGroupTax = styled(Card)`
  height: 85% !important;
  border: none;
  box-shadow: none;
  padding: 0 !important;
`;

export const TotalDiv = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${lightgrey} !important;
  border-radius: 8px;
  width: 100% !important;
`;

export const TypographyStyledTotal = styled(Typography)`
  font-weight: bold !important;
  font-family: ${opensans} !important;

  @media only screen and (max-width: 1920px) {
    font-size: 13px !important;
  }

  @media only screen and (min-width: 2000px) {
    font-size: 16px !important;
  }
`;

export const InputBaseMonetaryTotal = styled(InputBaseDecimalErp)`
  margin-top: 20px !important;
  .MuiTypography-root,
  input {
    font-weight: bold !important;
    font-family: ${opensans} !important;
    text-align: center !important;

    @media only screen and (max-width: 1920px) {
      font-size: 13px !important;
    }

    @media only screen and (min-width: 2000px) {
      font-size: 16px !important;
    }
  }
`;

export const InputBaseDecimalErpStyled = styled(InputBaseDecimalErp)`
  @media only screen and (max-width: 1920px) {
    font-size: 12px !important;
  }

  @media only screen and (min-width: 2000px) {
    font-size: 15px !important;
  }
`;

export const CustomDialog = styled(Dialog)`
  .MuiDialog-paperScrollPaper {
    &::-webkit-scrollbar {
      width: 12px;
    }
    ::-webkit-scrollbar-track {
      background: #f1f1f1;
      border-radius: 5px;
    }
    ::-webkit-scrollbar-thumb {
      background: ${primary};
      border-radius: 5px;
      border: 1px solid #f1f1f1;
    }
    ::-webkit-scrollbar-thumb:hover {
      background: ${blue};
    }
  }
`;

export const StyledSearchDialog = styled.div`
  .MuiDialogContent-root {
    padding: 0px 24px;
  }

  Button {
    span {
      font-family: ${mulish};
      font-weight: bolder;
      font-size: 0.975rem;
    }
  }

  ${Header} {
    .MuiChip-root {
      width: 100%;
      padding: 10px;
      margin: 0;

      .MuiChip-label {
        font-family: ${mulish};
        font-weight: bolder;
        font-size: 1rem;
      }
    }
  }

  ${Body} {
    ${Header} {
      margin-top: 10px;
    }

    Table {
      Thead {
        background-color: ${secondary};
        box-shadow: 3px 3px 3px ${(props) => props.theme.palette.darkgrey};
        tr {
          .Mui-checked {
            color: ${primary};
          }
          th {
            span {
              font-family: ${montserrat}, sans-serif !important;
            }
          }
        }
      }
      Tbody {
        td {
          font-family: ${opensans};
          .Mui-checked {
            color: ${primary};
          }
        }
        .Mui-selected {
          background-color: ${lightgreen};
          &:hover {
            background-color: ${lightgreen};
          }
          border: none;
        }
      }
    }
  }
`;

export const BtnToInvoice = styled(Btn)`
  margin: 0px;
  font-size: 12px !important;
  .material-icons {
    font-size: 12px !important;
  }
`;

export const GridStyledGroupInfo = styled(Grid)`
  > .MuiGrid-item {
    padding-bottom: 4px;
  }
`;

export const InputBaseDecimalTotalReadjustment = styled(InputBaseDecimalErp)`
  @media only screen and (max-width: 1920px) {
    font-size: 20px;
  }

  @media only screen and (min-width: 2000px) {
    font-size: 26px !important;
  }
`;

export const IconButtonStyled = styled(IconButton)`
  color: white !important;
  background-color: ${grey} !important;
`;

export const BtnOtherIndex = styled(Btn)`
  background-color: ${grey} !important;
  height: 100% !important;
  min-width: unset !important;
`;

export const CardStyled = styled(Card)`
  .MuiGrid-root .MuiGrid-container {
    min-height: 4vh !important;
  }
`;

export const CardExpired = styled(Card)`
  border-bottom: 4px solid ${(props) => props.bottomColor};
  height: 100%;
`;
